// extracted by mini-css-extract-plugin
module.exports = {"imgs":"Photos_imgs__1Y3Bt","img":"Photos_img__2LuZu","around":"Photos_around__hi6Sl"};